export default [
  {
    path: '/',
    name: 'patient-search',
    component: () => import('@/views/dashboard/Dashboard.vue'),
  }
]
